export class EditRlOrderAcceptanceRequest {
    id: number;
    poNumber: string;
    material: string;
    itemNo: string;
    buyer: string;
    poLine: string
    coNumber: string
    coDate: string
    poItem?:string

}